export default __webpack_public_path__ + "32b5a8db6c42bd80c3d34a7ee0fcf78b.svg";